<template>
  <section>
    <b-form class="mt-3" @submit.prevent="">
      <b-form-group label="Cliente">
          <b-form-input
          @focus="showClienteFilter=true"
            name="filterCliente"
            v-model="formAgendamentoCliente"
          ></b-form-input>
          <div class="filtered-select" v-if="showClienteFilter">
            <ul>
              <li v-for="cliente of filteredClientes" :key="cliente._id" @click="selectCliente(cliente)">{{cliente["nome"]}}</li>
            </ul>
          </div>
        </b-form-group>
      <b-form-group label="Valor do Depósito" label-for="exampleInput2">
        <b-form-input
          id="exampleInput2"
          v-model="deposito.valor"
          class="edit-input"
          v-money="money"
          required
          placeholder="00,00"
        />
      </b-form-group>
      <b-form-group label="Tipo">
        <b-form-select
          v-model="deposito.tipo"
        >
          <b-form-select-option value="deposito">Padrão</b-form-select-option>
          <b-form-select-option  value="deposito_internacao">Depósito para Internação</b-form-select-option>
        </b-form-select>
      </b-form-group>
      <b-form-group label="Comprovante de Pagamento" label-for="exampleInput4">
        <b-form-input
          id="exampleInput4"
          v-model="deposito.comprovante"
          class="edit-input"
          type="text"
          v-mask="'######.##'"
          required
          placeholder="000000-00"
        />
      </b-form-group>
      <b-form-group label="Nº de identificação" label-for="exampleInput5" v-if="deposito.forma_pagamento==='Pix'">
        <b-form-input
          id="exampleInput5"
          v-model="deposito.identificacao"
          class="edit-input"
          type="number"
          required
          placeholder=""
        />
      </b-form-group>
      <b-form-group label="Forma de Pagamento" label-for="exampleInput6">
        <b-form-select
          v-model="deposito.forma_pagamento"
          :options="formPgtOption"
        >
        </b-form-select>
      </b-form-group>
      
      <b-button type="submit" variant="primary" @click.prevent.stop="formValidate"
        >Salvar</b-button
      >
    </b-form>
    <loading :active.sync="isLoading" color="#ed969e" :can-cancel="true"></loading>
  </section>
</template>
<script>
import clienteMixin from '@/src/mixins/clienteMixin'
import {VMoney} from 'v-money'
import Loading from 'vue-loading-overlay'
import alertMixin from '@/src/mixins/alertMixin'

export default {
  components: {Loading},
  directives: {money: VMoney},
  mixins: [clienteMixin, alertMixin],
  props: ['deposito', 'onSubmit', 'onEdit'],
  data() {
    return {
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true
      },
      clientes:[],
      formPgtOption:[
        {value:'Dinheiro', text:'Dinheiro'},
        {value:'Pix', text:'Pix'},
      ],
      isLoading: false,
      showClienteFilter: false,
      formAgendamentoCliente: '',
      filteredClientes: [],
    }
  },
  watch:{
    formAgendamentoCliente(){
      this.filterCliente(this.formAgendamentoCliente)
      if(this.formAgendamentoCliente)
        this.showClienteFilter = true
    },
  },
  mounted(){
    this.listando()
    this.deposito.tipo = "deposito"
  },
  methods: {
    selectCliente(cliente){
      this.deposito.cliente = cliente._id
      this.formAgendamentoCliente = cliente.nome
      this.telefones = cliente.telefones?cliente.telefones.map(telefone=>{
        return {
            value: telefone,
            text: telefone.numero,
          }
      }):{}
      setTimeout(() => {
        this.showClienteFilter = false
      }, 100);
    },
    filterCliente(filter){
      if(!filter){
        this.filteredClientes = this.clientes.slice(0,4)
        return
      }
      
      this.filteredClientes = this.clientes.filter(i=>{ 
        return (i.nome.toLowerCase()).includes(filter.toLowerCase())||
                (i.cartao?(i.cartao.toLowerCase()).includes(filter.toLowerCase()):false)
      }).slice(0,4)
    },
    findCliente(id){
      this.isLoading = true
      return this.findOneCliente(id).then(response=>{
        this.isLoading = false
        return response.data
      })
    },
    listando(){
      this.isLoading = true
      this.clientes = []
      this.loadClientesBySelect()
        .then((clientes) => {
          this.clientes = clientes
          this.filterCliente(this.formAgendamentoCliente)
          this.isLoading = false
        }

        ).catch(() =>{
          this.isLoading = false
          this.errorMessage('Ops... Não conseguimos atender sua solicitação :(')
        }
        )
    },
    formValidate(){
      if (this.deposito.forma_pagamento) {
        if (this.deposito._id) {
          this.onEdit()
        } else {
          if (this.deposito.cliente) {
            this.onSubmit()
            this.formAgendamentoCliente = ""
          }
        }
      }
    }
  },
}
</script>
<style scoped>
.filtered-select{
  position: absolute;
  background-color: white;
  width: 95%;
  left: 5;
  z-index: 20;
}
.filtered-select ul{
  list-style: none;
  padding-left: 0px;
}
.filtered-select ul li{
  padding-top: 10px;
  padding-left: 10px;
  font-size: 14px;
  border-radius: 2%;
  justify-content: center;
}
.filtered-select ul li:hover{
  background-color: #0088a8;
  color: white;
  transition: 200ms;
}
</style>
